import React, {useState} from "react";
import {MAX_INPUT_NUMBER_VALUE, MIN_INPUT_NUMBER_VALUE} from "../../../../../utils/SurveyUtils";

function NumberViewMode(props) {
    const {questionData} = props;

    const minValue = questionData.options.min ? questionData.options.min : MIN_INPUT_NUMBER_VALUE;
    const maxValue = questionData.options.max ? questionData.options.max : MAX_INPUT_NUMBER_VALUE;

    const [numberValue, setNumberValue] = useState();

    const handleNumberValueChange = (event) => {
        let value = event.target.value;
        if(typeof value === "undefined" || value === "") {
            setNumberValue(undefined);
            return;
        }
        value = parseInt(value);

        if(value < minValue) {
            setNumberValue(minValue);
        } else
        if(value > maxValue) {
            setNumberValue(maxValue);
        } else
        if(value >= minValue && value <= maxValue) {
            setNumberValue(value);
        }
    };

    return (
        <div className="questionaire__builder__question__form questionaire__builder__question__form--flexRow number_view_mode pv-md">
            <span className="questionaire__builder__question__form__symbol">{questionData.options.prefix ? questionData.options.prefix : ""}</span>
            <input
                type="number"
                value={numberValue}
                min={minValue}
                max={maxValue}
                onChange={handleNumberValueChange}
                className="questionaire__builder__question__form__input"/>
            <span className="questionaire__builder__question__form__symbol">{questionData.options.suffix ? questionData.options.suffix : ""}</span>
        </div>
    )
}

export default NumberViewMode;